module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/object/assign.js
 ** module id = 215
 ** module chunks = 0 1 3 10 11 12 13 14 15 16 17 19 20 21 22 23 24 25 26
 **/